import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';
import MCSChartItem from 'modules/bottomPanel/components/elements/MCSChartItem';
import { useSelector } from 'app/store';
import { linksLinkMcsSelector } from 'modules/links/slice';

interface MCSChartItemContainerProps {
  index: number;
}

const MCSChartItemContainer = (props: MCSChartItemContainerProps) => {
  const { linkId } = useBottomPanel();
  const { index } = props;

  const isActive = useSelector((state) => (linkId ? linksLinkMcsSelector(state, linkId) === index : undefined));

  return <MCSChartItem isActive={isActive} />;
};

export default MCSChartItemContainer;
